module.exports = __webpack_public_path__ + "img/main_home_phone.80dac72.png";